module.exports = __webpack_public_path__ + "img/background_principal_mov-760.a74e07ee.webp";